import classNames from 'classnames';
import {TabContext} from 'components/TabProvider';
import {TTypographyVariant, Typography} from 'components/Typography';
import React, {forwardRef, InputHTMLAttributes, PropsWithChildren, useContext, useId} from 'react';
import style from './style.module.scss';

export interface IProps extends InputHTMLAttributes<HTMLInputElement> {
    className?: string;
    label?: string;
    isLabel?: boolean;
    disabled?: boolean;
    error?: boolean;
    fontVariant?: TTypographyVariant;
    labelClassname?: string;
    dataAutotestTarget?: string;
    dataAutotestTargetId?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, IProps>(function Checkbox(
    {
        className,
        label,
        isLabel,
        disabled,
        error,
        name,
        value,
        children,
        fontVariant = 'p',
        labelClassname,
        dataAutotestTarget,
        dataAutotestTargetId,
        ...restInputAttributes
    }: PropsWithChildren<IProps>,
    ref,
) {
    const uid = useId();
    const {name: checkboxName} = useContext(TabContext);

    return (
        <div
            className={classNames(
                style.checkbox,
                className,
                {
                    [style.disabled]: disabled,
                    [style.error]: error,
                },
                'checkbox',
            )}
            data-skeleton-item={true}
        >
            <input
                {...restInputAttributes}
                className={classNames(style.input, 'checkbox-input')}
                data-autotest-target={dataAutotestTarget}
                data-autotest-target-id={dataAutotestTargetId}
                disabled={disabled}
                id={uid}
                name={checkboxName || name}
                ref={ref}
                type={'checkbox'}
                value={value}
            />
            <label className={classNames(style.label, 'checkbox-label')} htmlFor={uid} tabIndex={0}>
                <div className={classNames(style.checkMark, 'checkbox-checkmark')} />
                {children}
                {isLabel && (
                    <Typography
                        className={classNames(style.text, labelClassname)}
                        element={'span'}
                        variant={fontVariant}
                    >
                        {label || value}
                    </Typography>
                )}
            </label>
        </div>
    );
});
